"use client";

import posthog from "posthog-js";
import { useEffect } from "react";

export function PostHogClientMount() {
  useEffect(() => {
    if ((posthog as any).__loaded) return;
    posthog.init("phc_QRmYLQpoX1lTircatQmIdEVpuML7wAyNZ0qmQh0rloM", {
      api_host: "https://us.i.posthog.com",
      defaults: "2026-01-30",
      loaded: (ph) => {
        console.log("PostHog loaded:", ph.get_distinct_id());
      },
    });
  }, []);
  return null;
}
